var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentPlanCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x92\xE1\x85\xA1\xE1\x86\xAF\xE1\x84\x87\xE1\x85\xAE\xE1\x84\x86\xE1\x85\xAE\xE1\x86\xAB\xE1\x84\x8B\xE1\x85\xB4 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23003_26694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 35,
    height: 35
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.5 3.66855H3.50003V37.6685H37.5V3.66855Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23003_26694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.1666 32.0671C18.3666 32.0671 12.8331 26.5336 12.8331 19.7336C12.8331 12.9336 18.3666 7.40009 25.1666 7.40009C31.9666 7.40009 37.5001 12.9336 37.5001 19.7336C37.5001 26.5336 31.9666 32.0671 25.1666 32.0671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.1495 29.5851C19.65 29.5851 15.179 25.1141 15.179 19.6146C15.179 14.1151 19.65 9.64413 25.1495 9.64413C30.649 9.64413 35.12 14.1151 35.12 19.6146C35.12 25.1141 30.649 29.5851 25.1495 29.5851Z",
    fill: "#FCDD44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.1666 27.0351C29.1956 27.0351 32.4681 23.7711 32.4681 19.7336C32.4681 15.6961 29.2041 12.4321 25.1666 12.4321C21.1291 12.4321 17.8651 15.6961 17.8651 19.7336C17.8651 23.7711 21.1291 27.0351 25.1666 27.0351Z",
    fill: "#F9BD46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.2385 25.097C13.8445 23.0655 12.7735 20.8725 12.0085 18.535C11.626 17.362 12.1275 16.1465 13.2495 15.662C13.4535 15.5515 13.53 15.322 13.4365 15.118L10.623 7.83354C10.4445 7.34054 9.90055 7.15354 9.48405 7.36604L9.16955 7.51904C5.63355 9.26154 4.12055 13.4265 5.65905 17.073L6.24555 18.4075C7.92855 22.36 9.77305 26.117 11.881 29.8655L12.5695 31.1405C14.5245 34.583 18.766 35.8495 22.285 34.192L22.5995 34.039C23.016 33.835 23.203 33.291 22.9225 32.849L18.868 26.1765C18.7575 25.9725 18.528 25.896 18.324 25.9895C17.2105 26.474 15.9355 26.134 15.2385 25.114V25.097Z",
    fill: "#EB435F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.046 12.8741L13.9805 7.49359C13.598 6.58409 12.612 6.15909 11.677 6.62659L11.0565 6.94109C10.64 7.14509 10.504 7.53609 10.6315 7.92709L13.309 14.8206C13.4875 15.3136 14.0315 15.5006 14.448 15.2881L15.281 14.8801C15.978 14.5996 16.3775 13.6901 16.046 12.8826H16.0545L16.046 12.8741Z",
    fill: "#C04257"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.2195 24.9015L19.3865 25.3095C18.97 25.5135 18.783 26.0575 19.0635 26.4995L22.8885 32.832C23.118 33.172 23.5855 33.325 23.9255 33.0955L24.546 32.781C25.379 32.373 25.753 31.285 25.2685 30.418L22.2595 25.4965C21.9025 24.7655 20.942 24.5275 20.211 24.8845H20.2195V24.9015Z",
    fill: "#C04257"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.6985 16.5376C22.013 16.5376 22.285 16.7501 22.3615 17.0646L23.305 21.0086H23.3645L24.4015 17.0561C24.478 16.7586 24.75 16.5461 25.0645 16.5461H25.26C25.566 16.5461 25.838 16.7586 25.923 17.0561L26.96 21.0256H27.011L27.9545 17.0731C28.031 16.7671 28.303 16.5461 28.6175 16.5461C29.068 16.5461 29.3995 16.9796 29.272 17.4131L27.8355 22.4366C27.7505 22.7256 27.487 22.9296 27.181 22.9296H26.909C26.603 22.9296 26.3395 22.7256 26.2545 22.4366L25.1835 18.7136H25.1325L24.053 22.4366C23.968 22.7256 23.7045 22.9296 23.3985 22.9296H23.1265C22.8205 22.9296 22.557 22.7256 22.472 22.4366L21.0355 17.4131C20.908 16.9796 21.2395 16.5461 21.69 16.5461L21.6985 16.5376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.8585 19.4956H20.466C20.228 19.4956 20.041 19.3086 20.041 19.0706C20.041 18.8326 20.228 18.6456 20.466 18.6456H29.8585C30.0965 18.6456 30.2835 18.8326 30.2835 19.0706C30.2835 19.3086 30.0965 19.4956 29.8585 19.4956Z",
    fill: "white"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPlanCall);
export default __webpack_public_path__ + "static/media/payment-plan-call.f3c0dc2991fd28baecdf114c37090129.svg";
export { ForwardRef as ReactComponent };